import { patchState, signalStore, withMethods, withState } from "@ngrx/signals";
import { ItemsAdBlock } from "../../../../api/packbo/models/items-ad-block";
import { ItemsCertifications } from "../../../../api/packbo/models/items-certifications";
import { ItemsHeaderBlock } from "../../../../api/packbo/models/items-header-block";
import { ItemsProductCategories } from "../../../../api/packbo/models/items-product-categories";
import { ItemsSuppliers } from "../../../../api/packbo/models/items-suppliers";

type CategoryState = {
    loading: boolean;
    supplierImagesLoading: boolean;
    category: ItemsProductCategories | null;
    subcategories: ItemsProductCategories[];
    filteredSubcategories: ItemsProductCategories[];
    suppliers: ItemsSuppliers[];
    itemsCertifications: ItemsCertifications[];
    adBlocks: ItemsAdBlock[];
    headerBlock: ItemsHeaderBlock | null;
    isEcoFriendly: boolean | null;
    certifications: number[] | null;
    pagination: {
        currentPage: number;
        totalPages: number;
        itemsPerPage: number;
    };
};

const initialState: CategoryState = {
    loading: false,
    supplierImagesLoading: true,
    category: null,
    subcategories: [],
    filteredSubcategories: [],
    suppliers: [],
    itemsCertifications: [],
    adBlocks: [],
    headerBlock: null,
    isEcoFriendly: null,
    certifications: null,
    pagination: {
        currentPage: 1,
        totalPages: 1,
        itemsPerPage: 48
    }
};

export const CategoryStore = signalStore(
    withState(initialState),
    withMethods((store) => ({
        setLoading(loading: boolean) {
            patchState(store, { loading });
        },
        setSupplierImagesLoading(supplierImagesLoading: boolean) {
            patchState(store, { supplierImagesLoading });
        },
        setCategory(category: ItemsProductCategories) {
            patchState(store, { category });
        },
        setSubcategories(subcategories: ItemsProductCategories[]) {
            patchState(store, { subcategories });
        },
        setFilteredSubcategories(filteredSubcategories: ItemsProductCategories[]) {
            patchState(store, { filteredSubcategories });
        },
        setSuppliers(suppliers: ItemsSuppliers[]) {
            patchState(store, { suppliers });
        },
        setItemsCertifications(itemsCertifications: ItemsCertifications[]) {
            patchState(store, { itemsCertifications });
        },
        setAdBlocks(adBlocks: ItemsAdBlock[]) {
            patchState(store, { adBlocks });
        },
        setHeaderBlock(headerBlock: ItemsHeaderBlock | null) {
            patchState(store, { headerBlock });
        },
        setIsEcoFriendly(isEcoFriendly: boolean | null) {
            patchState(store, { isEcoFriendly });
        },
        setCertifications(certifications: number[] | null) {
            patchState(store, { certifications });
        },
        setPagination(pagination: Partial<CategoryState["pagination"]>) {
            patchState(store, {
                pagination: { ...store.pagination(), ...pagination }
            });
        },
        resetPagination() {
            patchState(store, {
                pagination: {
                    currentPage: 1,
                    totalPages: 1,
                    itemsPerPage: 48
                }
            });
        }
    }))
);
